export const ConfirmDialogDataTour = {
  dialog: "confirmDialog",
  noButton: "confirmDialog-no-button",
  yesButton: "confirmDialog-yes-button",
} as const;
